import React from "react";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

//CONTEXTS
import AuthState from "../../context/authentication/authState";
//CONTEXTS

import { LoginForm, RegisterForm } from "../../components";

import CreatorMain from "../../pages/CreatorMain";

import NotFound from "../../components/generalComponents/NotFound";

//token
import tokenAuth from "../../config/tokenAuth";
import PrivateRoute from "./PrivateRoute";
import ProposalPublic from "../../components/Proposals/ProposalPublic";

const Root = () => {
  return <div>Home</div>;
};

const Trying = () => {
  return <div>Private route</div>;
};

//Check if ther is a token
const token = localStorage.getItem("token");
if (token) {
  tokenAuth(token); // toma el token y lo envia via headers
}

const AppRouter = () => {
  return (
    <AuthState>
      <Router>
        <Switch>
          <Redirect exact from="/" to="/login" />

          <Route exact path="/" component={Root} />

          <Route exact path="/login" component={LoginForm} />

          <Route exact path="/register" component={RegisterForm} />

          <PrivateRoute path="/private" component={Trying} />

          <Route
            path={`/proposal-public-link/:id`}
            component={ProposalPublic}
          />

          <PrivateRoute path="/creator" component={CreatorMain} />

          <Route path="*" component={NotFound} />
        </Switch>
      </Router>
    </AuthState>
  );
};

export default AppRouter;
